import { render, staticRenderFns } from "./payment-form.vue?vue&type=template&id=de497a14&"
import script from "./payment-form.vue?vue&type=script&lang=ts&"
export * from "./payment-form.vue?vue&type=script&lang=ts&"
import style0 from "./payment-form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
